/**
 * Tablo yetkilendirme scope'ları ve bağımlılıkları
 */

export const TABLE_PERMISSION_SCOPES = {
    // Temel Yetkiler
    TABLE_READ: "table-read",
    TABLE_META_EDIT: "table-meta-edit",

    // Kayıt Yetkileri
    RECORD_CREATE: "record-create",
    RECORD_UPDATE: "record-update",
    RECORD_DELETE: "record-delete",

    // View Yetkileri
    VIEW_CREATE: "view-create",
    VIEW_UPDATE: "view-update",
    VIEW_DELETE: "view-delete",

    // Page Yetkileri
    PAGE_READ: "page-read",
    PAGE_CREATE: "page-create",
    PAGE_UPDATE: "page-update",
    PAGE_DELETE: "page-delete",

    // Field Yetkileri
    FIELD_CREATE: "field-create",
    FIELD_UPDATE: "field-update",
    FIELD_DELETE: "field-delete",

    // Widget Yetkileri
    WIDGET_CREATE: "widget-create",
    WIDGET_UPDATE: "widget-update",
    WIDGET_DELETE: "widget-delete",

    // İçeri/Dışarı Aktarım
    BULK_IMPORT: "bulk-import",
    EXPORT: "export",
};

/**
 * Her scope için bağımlılıkları tanımlar
 * Bir scope'a sahip olabilmek için bağımlı scope'lara da sahip olunmalıdır
 */
export const PERMISSION_DEPENDENCIES = {
    // Temel yetkiler
    [TABLE_PERMISSION_SCOPES.TABLE_READ]: [],
    [TABLE_PERMISSION_SCOPES.TABLE_META_EDIT]: [TABLE_PERMISSION_SCOPES.TABLE_READ],

    // Kayıt yetkileri - table-read'e bağımlı
    [TABLE_PERMISSION_SCOPES.RECORD_CREATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.RECORD_UPDATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.RECORD_DELETE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],

    // View yetkileri - table-read'e bağımlı
    [TABLE_PERMISSION_SCOPES.VIEW_CREATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.VIEW_UPDATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.VIEW_DELETE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],

    // Page yetkileri - table-read'e bağımlı
    [TABLE_PERMISSION_SCOPES.PAGE_READ]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.PAGE_CREATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ, TABLE_PERMISSION_SCOPES.PAGE_READ],
    [TABLE_PERMISSION_SCOPES.PAGE_UPDATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ, TABLE_PERMISSION_SCOPES.PAGE_READ],
    [TABLE_PERMISSION_SCOPES.PAGE_DELETE]: [TABLE_PERMISSION_SCOPES.TABLE_READ, TABLE_PERMISSION_SCOPES.PAGE_READ],

    // Field yetkileri - table-read'e bağımlı
    [TABLE_PERMISSION_SCOPES.FIELD_CREATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.FIELD_UPDATE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
    [TABLE_PERMISSION_SCOPES.FIELD_DELETE]: [TABLE_PERMISSION_SCOPES.TABLE_READ],

    // Widget yetkileri - ilgili page yetkilerine bağımlı
    [TABLE_PERMISSION_SCOPES.WIDGET_CREATE]: [
        TABLE_PERMISSION_SCOPES.TABLE_READ,
        TABLE_PERMISSION_SCOPES.PAGE_READ,
        TABLE_PERMISSION_SCOPES.PAGE_CREATE,
    ],
    [TABLE_PERMISSION_SCOPES.WIDGET_UPDATE]: [
        TABLE_PERMISSION_SCOPES.TABLE_READ,
        TABLE_PERMISSION_SCOPES.PAGE_READ,
        TABLE_PERMISSION_SCOPES.PAGE_UPDATE,
    ],
    [TABLE_PERMISSION_SCOPES.WIDGET_DELETE]: [
        TABLE_PERMISSION_SCOPES.TABLE_READ,
        TABLE_PERMISSION_SCOPES.PAGE_READ,
        TABLE_PERMISSION_SCOPES.PAGE_DELETE,
    ],

    // İçeri/Dışarı aktarım
    [TABLE_PERMISSION_SCOPES.BULK_IMPORT]: [TABLE_PERMISSION_SCOPES.TABLE_READ, TABLE_PERMISSION_SCOPES.RECORD_CREATE],
    [TABLE_PERMISSION_SCOPES.EXPORT]: [TABLE_PERMISSION_SCOPES.TABLE_READ],
};

/**
 * Scope grupları - UI'da gruplandırma için
 */
export const SCOPE_GROUPS = {
    BASIC: {
        id: "basic",
        titleKey: "tables.permissions.groups.basic",
        scopes: [TABLE_PERMISSION_SCOPES.TABLE_READ, TABLE_PERMISSION_SCOPES.TABLE_META_EDIT],
        icon: "visibility",
    },
    RECORD: {
        id: "record",
        titleKey: "tables.permissions.groups.record",
        scopes: [
            TABLE_PERMISSION_SCOPES.RECORD_CREATE,
            TABLE_PERMISSION_SCOPES.RECORD_UPDATE,
            TABLE_PERMISSION_SCOPES.RECORD_DELETE,
        ],
        icon: "edit_note",
    },
    VIEW: {
        id: "view",
        titleKey: "tables.permissions.groups.view",
        scopes: [
            TABLE_PERMISSION_SCOPES.VIEW_CREATE,
            TABLE_PERMISSION_SCOPES.VIEW_UPDATE,
            TABLE_PERMISSION_SCOPES.VIEW_DELETE,
        ],
        icon: "filter_alt",
    },
    PAGE: {
        id: "page",
        titleKey: "tables.permissions.groups.page",
        scopes: [
            TABLE_PERMISSION_SCOPES.PAGE_READ,
            TABLE_PERMISSION_SCOPES.PAGE_CREATE,
            TABLE_PERMISSION_SCOPES.PAGE_UPDATE,
            TABLE_PERMISSION_SCOPES.PAGE_DELETE,
        ],
        icon: "dashboard",
    },
    FIELD: {
        id: "field",
        titleKey: "tables.permissions.groups.field",
        scopes: [
            TABLE_PERMISSION_SCOPES.FIELD_CREATE,
            TABLE_PERMISSION_SCOPES.FIELD_UPDATE,
            TABLE_PERMISSION_SCOPES.FIELD_DELETE,
        ],
        icon: "view_column",
    },
    WIDGET: {
        id: "widget",
        titleKey: "tables.permissions.groups.widget",
        scopes: [
            TABLE_PERMISSION_SCOPES.WIDGET_CREATE,
            TABLE_PERMISSION_SCOPES.WIDGET_UPDATE,
            TABLE_PERMISSION_SCOPES.WIDGET_DELETE,
        ],
        icon: "widgets",
    },
    IMPORT_EXPORT: {
        id: "import_export",
        titleKey: "tables.permissions.groups.importExport",
        scopes: [TABLE_PERMISSION_SCOPES.BULK_IMPORT, TABLE_PERMISSION_SCOPES.EXPORT],
        icon: "import_export",
    },
};

/**
 * Scope açıklamaları - UI'da gösterilmek üzere
 */
export const SCOPE_LABELS = {
    [TABLE_PERMISSION_SCOPES.TABLE_READ]: {
        labelKey: "tables.permissions.scopes.tableRead",
        descriptionKey: "tables.permissions.scopes.tableReadDesc",
    },
    [TABLE_PERMISSION_SCOPES.TABLE_META_EDIT]: {
        labelKey: "tables.permissions.scopes.tableMetaEdit",
        descriptionKey: "tables.permissions.scopes.tableMetaEditDesc",
    },
    [TABLE_PERMISSION_SCOPES.RECORD_CREATE]: {
        labelKey: "tables.permissions.scopes.recordCreate",
        descriptionKey: "tables.permissions.scopes.recordCreateDesc",
    },
    [TABLE_PERMISSION_SCOPES.RECORD_UPDATE]: {
        labelKey: "tables.permissions.scopes.recordUpdate",
        descriptionKey: "tables.permissions.scopes.recordUpdateDesc",
    },
    [TABLE_PERMISSION_SCOPES.RECORD_DELETE]: {
        labelKey: "tables.permissions.scopes.recordDelete",
        descriptionKey: "tables.permissions.scopes.recordDeleteDesc",
    },
    [TABLE_PERMISSION_SCOPES.VIEW_CREATE]: {
        labelKey: "tables.permissions.scopes.viewCreate",
        descriptionKey: "tables.permissions.scopes.viewCreateDesc",
    },
    [TABLE_PERMISSION_SCOPES.VIEW_UPDATE]: {
        labelKey: "tables.permissions.scopes.viewUpdate",
        descriptionKey: "tables.permissions.scopes.viewUpdateDesc",
    },
    [TABLE_PERMISSION_SCOPES.VIEW_DELETE]: {
        labelKey: "tables.permissions.scopes.viewDelete",
        descriptionKey: "tables.permissions.scopes.viewDeleteDesc",
    },
    [TABLE_PERMISSION_SCOPES.PAGE_READ]: {
        labelKey: "tables.permissions.scopes.pageRead",
        descriptionKey: "tables.permissions.scopes.pageReadDesc",
    },
    [TABLE_PERMISSION_SCOPES.PAGE_CREATE]: {
        labelKey: "tables.permissions.scopes.pageCreate",
        descriptionKey: "tables.permissions.scopes.pageCreateDesc",
    },
    [TABLE_PERMISSION_SCOPES.PAGE_UPDATE]: {
        labelKey: "tables.permissions.scopes.pageUpdate",
        descriptionKey: "tables.permissions.scopes.pageUpdateDesc",
    },
    [TABLE_PERMISSION_SCOPES.PAGE_DELETE]: {
        labelKey: "tables.permissions.scopes.pageDelete",
        descriptionKey: "tables.permissions.scopes.pageDeleteDesc",
    },
    [TABLE_PERMISSION_SCOPES.FIELD_CREATE]: {
        labelKey: "tables.permissions.scopes.fieldCreate",
        descriptionKey: "tables.permissions.scopes.fieldCreateDesc",
    },
    [TABLE_PERMISSION_SCOPES.FIELD_UPDATE]: {
        labelKey: "tables.permissions.scopes.fieldUpdate",
        descriptionKey: "tables.permissions.scopes.fieldUpdateDesc",
    },
    [TABLE_PERMISSION_SCOPES.FIELD_DELETE]: {
        labelKey: "tables.permissions.scopes.fieldDelete",
        descriptionKey: "tables.permissions.scopes.fieldDeleteDesc",
    },
    [TABLE_PERMISSION_SCOPES.WIDGET_CREATE]: {
        labelKey: "tables.permissions.scopes.widgetCreate",
        descriptionKey: "tables.permissions.scopes.widgetCreateDesc",
    },
    [TABLE_PERMISSION_SCOPES.WIDGET_UPDATE]: {
        labelKey: "tables.permissions.scopes.widgetUpdate",
        descriptionKey: "tables.permissions.scopes.widgetUpdateDesc",
    },
    [TABLE_PERMISSION_SCOPES.WIDGET_DELETE]: {
        labelKey: "tables.permissions.scopes.widgetDelete",
        descriptionKey: "tables.permissions.scopes.widgetDeleteDesc",
    },
    [TABLE_PERMISSION_SCOPES.BULK_IMPORT]: {
        labelKey: "tables.permissions.scopes.bulkImport",
        descriptionKey: "tables.permissions.scopes.bulkImportDesc",
    },
    [TABLE_PERMISSION_SCOPES.EXPORT]: {
        labelKey: "tables.permissions.scopes.export",
        descriptionKey: "tables.permissions.scopes.exportDesc",
    },
};

/**
 * Tüm scope'ları sıralı olarak döndürür
 */
export function getAllScopes() {
    return Object.values(TABLE_PERMISSION_SCOPES);
}

/**
 * Belirli bir grup için scope'ları döndürür
 */
export function getScopesByGroup(groupId) {
    const group = Object.values(SCOPE_GROUPS).find((g) => g.id === groupId);
    return group ? group.scopes : [];
}

/**
 * Bir scope'un bağımlılıklarını döndürür
 */
export function getScopeDependencies(scope) {
    return PERMISSION_DEPENDENCIES[scope] || [];
}

/**
 * Bir scope'un label ve description key'lerini döndürür
 */
export function getScopeLabel(scope) {
    return SCOPE_LABELS[scope] || { labelKey: scope, descriptionKey: scope };
}

